import {
  UpdateLatestSelectedNodeIdAction,
  UserClicksElementsActionTypes
} from '../actions';
import { initialState } from '../state';

export function latestSelectedNodeId(state = initialState.latestSelectedNodeId, action: UpdateLatestSelectedNodeIdAction): string {
  switch (action.type) {
    case UserClicksElementsActionTypes.UPDATE_LATEST_SELECTED_NODE_ID:
      return action.payload.id;
    default: {
      return state;
    }
  }
}
